var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useTranslation as useTranslationReactI18Next, } from 'react-i18next';
const WrappedHook = ({ tKey, tOptions, namespace, options }) => {
    const { t } = useTranslationReactI18Next(namespace, options);
    return <>{t(tKey, tOptions)}</>;
};
const getMockedHook = ({ namespace, options, }) => {
    const t = options.i18n
        ? (tKey, tOptions) => (<WrappedHook namespace={namespace} options={options} tKey={tKey} tOptions={tOptions}/>)
        : (tKey, tOptions) => {
            if (tOptions && Object.values(tOptions).length) {
                Object.entries(tOptions).forEach(([interpolationKey, interpolationValue]) => {
                    const regex = new RegExp(`{{${interpolationKey}}}`, 'ig');
                    if (regex.test(tKey)) {
                        tKey = tKey.replace(regex, interpolationValue);
                    }
                });
            }
            return tKey;
        };
    const i18n = options.i18n;
    const ready = !!options.i18n;
    return { t, i18n, ready };
};
export const useTranslation = (namespace = 'translation', options = {}) => {
    const [instance, setInstance] = useState();
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!navigator.language.startsWith('en') && !instance) {
                const module = yield import(
                /* webpackChunkName: 'i18next' */ '@embed/i18next');
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                setInstance(module.default);
            }
        }))();
    }, []);
    return getMockedHook({
        namespace,
        options: Object.assign(Object.assign({}, options), { i18n: instance }),
    });
};
